// Removed unused Papa import as CSV parsing is done manually

export const loadTradingViewData = async (filePath) => {
  try {
    console.log('Fetching file from:', filePath);
    const response = await fetch(filePath);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${filePath} (${response.status})`);
    }
    
    const csvText = await response.text();
    console.log('CSV text length:', csvText.length);
    
    const rows = csvText.split('\n');
    console.log('Number of rows:', rows.length);
    
    // Skip header row and empty rows
    const data = rows
      .slice(1)
      .filter(row => row.trim() !== '')
      .map(row => {
        const values = row.split(',');
        return {
          symbol: values[0],
          preMarketClose: values[1],
          preMarketChange: values[2],
          preMarketGap: values[3],
          preMarketVolume: values[4],
          change: values[5],
          price: values[6],
          gap: values[7],
          volume: values[8],
          volPrice: values[9],
          volChange: values[10],
          postMarketClose: values[11],
          postMarketChange: values[12],
          postMarketVolume: values[13],
          avgVolume10D: values[14],
          avgVolume30D: values[15],
          volatility: values[16],
          currentRatioFQ: values[17],
          debtEquityFQ: values[18],
          grossMarginFY: values[19],
          operatingMarginFY: values[20],
          netMarginFY: values[21],
          revenueGrowthTTM: values[22],
          ebitdaGrowthTTM: values[23],
          netIncomeGrowthTTM: values[24],
          grossProfitGrowthTTM: values[25],
          pe: values[26],
          pegTTM: values[27],
          ps: values[28],
          evRevenueTTM: values[29],
          epsDilFQ: values[30],
          netIncomeFY: values[31],
          epsEstimatesFQ: values[32],
          buybackYield: values[33],
          roeFY: values[34],
          fcfMarginFY: values[35],
          fcfGrowthTTM: values[36],
          epsDilGrowthTTM: values[37],
          capexGrowthTTM: values[38],
          revenueFY: values[39],
          ebitdaTTM: values[40],
          operatingCFTTM: values[41],
          totalEquityFQ: values[42]
        };
      });
    
    console.log('Parsed data first row:', data[0]);
    return data;
  } catch (error) {
    console.error('Error loading TradingView data:', error);
    throw error;
  }
};

export const getCurrentDataFilePath = () => {
  return '/tradingviewdata/extracted_data_2024-12-28T22-25-08-093Z.csv';
};
